/**
 * App releases — mobile app version / force-update management.
 *
 * Superadmin manage:  GET/POST /superadmin/app-versions/
 *                     PATCH    /superadmin/app-versions/<id>/
 * Public (the mobile app itself calls this on startup):
 *                     GET /app-version/check/?platform=android&build=N
 *
 * A release row's grace countdown runs from its created_at — that's why
 * publishing is always CREATE (new row), never editing builds into an old
 * row. The backend rejects build edits on PATCH for the same reason.
 */

import { apiService } from './api'

export const appReleasesAPI = {
  list: () => apiService.get('/superadmin/app-versions/'),
  publish: (payload) => apiService.post('/superadmin/app-versions/', payload),
  update: (id, payload) => apiService.patch(`/superadmin/app-versions/${id}/`, payload),
  // Handy for the panel's "what would a user on build N see?" self-check.
  check: (platform, build) =>
    apiService.get(`/app-version/check/?platform=${platform}&build=${build}&version=panel-check`),
}
